var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";

import styles from "./About.css";

var loadGreenhouse = function loadGreenhouse() {
  window.Grnhse.Settings.scrollOnLoad = false;
  window.Grnhse.Iframe.load();
};

var Jobs = function (_Component) {
  _inherits(Jobs, _Component);

  function Jobs() {
    _classCallCheck(this, Jobs);

    return _possibleConstructorReturn(this, (Jobs.__proto__ || Object.getPrototypeOf(Jobs)).apply(this, arguments));
  }

  _createClass(Jobs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!window.Grnhse) {
        var ghEmbedScript = document.createElement("script");
        ghEmbedScript.setAttribute("src", "https://boards.greenhouse.io/embed/job_board/js?for=axios");
        document.body.appendChild(ghEmbedScript);
        ghEmbedScript.onload = function () {
          return loadGreenhouse();
        };
      } else {
        loadGreenhouse();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(
        "div",
        { className: styles.aboutSections },
        React.createElement(
          "div",
          { className: styles.sectionHeaders },
          React.createElement(
            "h4",
            null,
            "Jobs at Axios"
          )
        ),
        React.createElement(
          "div",
          { className: styles.aboutContent },
          React.createElement("div", { id: "grnhse_app" })
        )
      );
    }
  }]);

  return Jobs;
}(Component);

export default Jobs;


// WEBPACK FOOTER //
// ./src/about/components/About/Jobs.js